import * as React from 'react'

import { IconPropsType } from '../types'

export const GoogleCalendarIcon = (props: IconPropsType) => {
   const { width = 20, height = 20, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         fill='none'
         {...rest}
      >
         <path
            fill='#1967D2'
            d='M18.492.875h-3.25v4.711h4.757V2.203c.001 0-.235-1.2-1.506-1.328ZM15.243 20.854V20.875L20 16.165h-.043l-4.714 4.689Z'
         />
         <path
            fill='#FBBC05'
            d='M20 16.163v-.042l-.043.043H20ZM20 5.586h-4.757V16.12H20V5.586Z'
         />
         <path
            fill='#EA4335'
            d='M19.957 16.164h-4.714v4.69l4.714-4.69ZM15.243 16.163h4.714l.043-.042h-4.757v.043Z'
         />
         <path
            fill='#34A853'
            d='M15.231 20.865h.011v-.011l-.011.011ZM4.65 16.121v4.744h10.581l.012-4.744H4.65Z'
         />
         <path
            fill='#34A853'
            d='M15.242 16.164v-.043l-.011 4.744.011-.012v-4.69Z'
         />
         <path
            fill='#188038'
            d='M0 16.121v3.298c.043 1.07 1.2 1.446 1.2 1.446h3.45V16.12H0Z'
         />
         <path
            fill='#4285F4'
            d='M4.65 5.586h10.593V.876H1.333S.085 1.003 0 2.33v13.79h4.65V5.587Z'
         />
         <path
            fill='#4285F4'
            d='M8.116 13.989c-.243 0-.476-.032-.702-.095a2.089 2.089 0 0 1-.605-.284 2.214 2.214 0 0 1-.494-.49 2.247 2.247 0 0 1-.32-.68l1.065-.423c.075.287.202.505.38.655.18.143.404.215.676.215.12 0 .236-.018.346-.052a.927.927 0 0 0 .285-.164.767.767 0 0 0 .19-.24.685.685 0 0 0 .079-.328.702.702 0 0 0-.286-.594c-.185-.143-.441-.215-.77-.215h-.51V10.27h.466c.116 0 .228-.014.338-.043a.867.867 0 0 0 .286-.13.642.642 0 0 0 .199-.232.704.704 0 0 0 .078-.335.597.597 0 0 0-.208-.474c-.139-.126-.326-.19-.563-.19-.254 0-.45.07-.588.207a1.08 1.08 0 0 0-.277.448l-1.039-.422c.052-.143.13-.29.234-.439.104-.155.234-.293.39-.413a1.95 1.95 0 0 1 .562-.301c.213-.08.459-.12.736-.12.282 0 .539.04.77.12.236.08.438.192.606.335a1.433 1.433 0 0 1 .528 1.12c0 .172-.023.327-.07.464-.04.138-.095.261-.164.37a1.291 1.291 0 0 1-.51.465v.07c.276.108.504.283.683.524.185.241.277.545.277.913 0 .258-.05.496-.147.714-.098.212-.24.399-.424.56-.18.16-.395.284-.65.37a2.48 2.48 0 0 1-.847.137ZM12.25 13.85V9.29l-1.046.439-.416-.956 1.74-.81h.856v5.889h-1.133Z'
         />
      </svg>
   )
}
